import Navbar from './Navbar';
import Footer from './Footer';

type LayoutProps = {
  children: React.ReactNode;
};

export default function Layout({ children }: LayoutProps) {
  return (
    <div className="min-h-screen ">
      <Navbar />
      <main className="pt-20">{children}</main>
      <Footer />
    </div>
  );
} 